// extracted by mini-css-extract-plugin
var _1 = "CalendarRailBuilding-moduleskeleton__eU44P Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
